import {
  createStyles, FormHelperText, Grid, makeStyles, MenuItem, OutlinedInput, Select, Theme,
} from '@material-ui/core';
import clsx from 'clsx';
import { getStringArrayDay, MONTH_ARRAY, YEAR_ARRAY } from 'constants/reservation';
import React, { useState } from 'react';
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';

interface IFormElementDateSelect {
  labelInput: string;
}

const FormElementDateSelect : React.FC<IFormElementDateSelect> = ({
  labelInput,
}) => {
  const {
    getValues, setValue, control, errors,
  } = useFormContext();
  const classes = useStyles();
  const yearArr = YEAR_ARRAY || [];
  const monthArr = MONTH_ARRAY || [];
  const [dayArr, setDayArr] = useState<string[]>(getStringArrayDay(monthArr[0], yearArr[0]));

  const handleChangeListDay = (MonthNumber: string | number, YearNumber: string | number) => {
    const dayArrNew = getStringArrayDay(MonthNumber, YearNumber);
    setDayArr(dayArrNew);
    if (!dayArrNew?.includes(getValues('customerBirthdayDay'))) {
      setValue('customerBirthdayDay', dayArrNew[0]);
    }
  };


  return (
    <Grid container={true} spacing={2} className={classes.formElementControl}>
      <Grid item={true} xs={12} md={4}>
        <div className={classes.formLabelSelect}>
          <p>
            <span>必須</span>
            {labelInput}
          </p>
        </div>
      </Grid>
      <Grid item={true} xs={12} md={8} className={classes.formSelectContainer}>
        <Controller
          name="customerBirthdayYear"
          control={control}
          render={({ ref, ...rest }: ControllerRenderProps) => (
            <Select
              {...rest}
              inputRef={ref}
              className={clsx(classes.selectComponent, classes.yearSelect)}
              displayEmpty={true}
              input={(<OutlinedInput classes={{ notchedOutline: classes.notchedOutline }} />)}
              error={!!errors.customerBirthdayYear}
              onChange={(e) => {
                const value = Number(e?.target?.value || yearArr[0]);
                rest.onChange(value);
                handleChangeListDay(getValues('customerBirthdayMonth'), value);
              }}
            >
              {
              [
                yearArr.map((item) => (
                  <MenuItem key={item} value={String(item)}>
                    {item}
                  </MenuItem>
                )),
              ]
              }
            </Select>
          )}
        />
        <div className={classes.selectMiddleLabel}>
          <p>年</p>
        </div>
        <Controller
          name="customerBirthdayMonth"
          control={control}
          render={({ ref, ...rest }: ControllerRenderProps) => (
            <Select
              {...rest}
              inputRef={ref}
              className={clsx(classes.selectComponent, classes.monthSelect)}
              displayEmpty={true}
              input={(<OutlinedInput classes={{ notchedOutline: classes.notchedOutline }} />)}
              error={!!errors.customerBirthdayMonth}
              onChange={(e) => {
                const value = String(e?.target?.value || monthArr[0]);
                rest.onChange(value);
                handleChangeListDay(value, getValues('customerBirthdayYear'));
              }}
            >
              {
            [
              monthArr.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              )),
            ]
          }
            </Select>
          )}
        />
        <div className={classes.selectMiddleLabel}>
          <p>月</p>
        </div>
        <Controller
          name="customerBirthdayDay"
          control={control}
          render={({ ref, ...rest }: ControllerRenderProps) => (
            <Select
              {...rest}
              inputRef={ref}
              className={clsx(classes.selectComponent, classes.daySelect)}
              displayEmpty={true}
              input={(<OutlinedInput classes={{ notchedOutline: classes.notchedOutline }} />)}
              error={!!errors.customerBirthdayDay}
            >
              {
                  [
                    dayArr.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    )),
                  ]
                }
            </Select>
          )}
        />
        <div className={classes.selectMiddleLabel}>
          <p>日</p>
        </div>
      </Grid>
      <FormHelperText error={!!errors?.customerBirthdayYear || !!errors?.customerBirthdayMonth || !!errors?.customerBirthdayDay}>{errors?.customerBirthdayYear?.message || errors?.customerBirthdayMonth?.message || errors?.customerBirthdayDay?.message}</FormHelperText>
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  formElementControl: {
    marginBottom: '29px',
    marginLeft: '10px',
    width: 'calc(100% - 55px)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      width: '100%',
    },
  },
  formLabelSelect: {
    backgroundColor: '#EBEBEB',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '37px',
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1a1a1a',
      letterSpacing: '0.8px',
      fontWeight: 600,
      textAlign: 'center',
      paddingLeft: '12px',
      '& span': {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ffffff',
        backgroundColor: '#d0111b',
        marginRight: '0.3em',
      },
    },
  },
  formSelectContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  },
  selectComponent: {
    width: '100%',
    borderRadius: '5px',
    cursor: 'pointer',
    fontFamily: 'Noto Sans JP',
    fontSize: '18px',
    fontWeight: 500,
    // lineHeight: '26px',
    letterSpacing: '0.8px',
    color: '#606060',
    [theme.breakpoints.down('sm')]: {
      height: '56px',
    },
  },

  optionComponent: {
    fontWeight: 'normal',
    display: 'block',
    whiteSpace: 'nowrap',
    minHeight: '1.2em',
    padding: ' 0px 2px 1px',
  },

  yearSelect: {
    fontSize: '16px',
    width: '87px',
    lineHeight: '19px',
    textAlign: 'left',
  },

  monthSelect: {
    fontSize: '16px',
    width: '71px',
    lineHeight: '19px',
    textAlign: 'left',
  },

  daySelect: {
    fontSize: '16px',
    width: '71px',
    lineHeight: '19px',
    textAlign: 'left',
  },

  selectMiddleLabel: {
    fontSize: '18px',
    lineHeight: '26px',
    margin: 'auto 16px',
  },
  notchedOutline: {
    // NOTE: the legend element is a child of the notchedOutline component
    '& legend': {
      maxWidth: '1000px',
    },
  },
}));

export default FormElementDateSelect;
